export default __webpack_public_path__ + "static/media/17.3bf5366b.png";